import { isEmpty, trim } from 'lodash';
import styled from 'styled-components';
import EditableCell from '../../../EditableCell';
import { Row } from '../../styles';
import { ToggleSubcomponent } from '../../Table/table-config';

export const changedValueCellHexColor = '#bcbcbc';

export const columns = [
  {
    Header: () => (
      <Row>
        <span>
          Group <br />
          weight
        </span>{' '}
        %
      </Row>
    ),
    rowSpan: 2,
    id: 'groupWeight',
    getCustomStyles: () => ({
      //   width: '13%'
      width: '7rem',
    }),
    columns: [
      {
        Header: 'groupWeight INVISIBLE',
        getCustomStyles: () => ({
          display: 'none',
        }),
      },
    ],
  },
  {
    Header: '%',
    getCustomStyles: () => ({
      //   width: '7%',
      width: '3.5rem',
    }),
    rowSpan: 2,
    columns: [
      {
        Header: 'SCORE WEIGHT INVISIBLE',
        accessor: 'scoreWeight',
        getCustomStyles: () => ({
          //   width: '7%',
          display: 'none',
        }),
        Cell: ({ value }) => `${value}%`,
      },
    ],
  },
  {
    Header: 'Criteria',
    getCustomStyles: () => ({
      width: '30%',
    }),
    rowSpan: 2,
    id: 'criteria-header',
    columns: [
      {
        Header: 'Criteria INVISIBLE',
        accessor: 'criteria',
        getCustomStyles: () => ({
          display: 'none',
        }),
      },
    ],
  },
  {
    Header: 'Phase',
    getCustomStyles: () => ({
      //   width: '9%',
      width: '8rem',
    }),
    rowSpan: 2,
    columns: [
      {
        Header: 'Phase INVISIBLE',
        accessor: 'phase',
        getCustomStyles: () => ({
          display: 'none',
        }),
        Cell: ({ row: { original } }) => `Phase ${original.phase}`,
      },
    ],
  },
  {
    Header: 'Score (%)',
    getCustomStyles: () => ({
      //   width: '11%',
      width: '5rem',
    }),
    rowSpan: 2,
    columns: [
      {
        Header: 'Score INVISIBLE',
        accessor: 'score',
        getCustomStyles: () => ({
          display: 'none',
          padding: 0,
        }),
        Cell: (props) => {
          const latestHistoryData = props.getLatestRowData(props.row.index);
          const latestReasoning = latestHistoryData?.score || '';
          const isScoreChanged = latestHistoryData && latestReasoning !== (props.value ?? '');
          return (
            <CellWithBackground color={isScoreChanged && props.isAdmin && changedValueCellHexColor}>
              {props.isAdmin ? (
                <EditableCell
                  {...props}
                  type='number'
                  isDisabled={props.isBespokeModule || props.row.values.scoreWeight <= 0}
                  isValid={isValidScore}
                />
              ) : (
                (props.value || '-') + '%'
              )}
            </CellWithBackground>
          );
        },
      },
    ],
  },
  {
    Header: 'Reasoning',
    getCustomStyles: () => ({
      //   width: '33%',
      // width: 'calc(100% - 25rem)',
      // width: '35%',
      //   display: 'none',
    }),
    rowSpan: 2,
    columns: [
      {
        Header: 'Reasoning INVISIBLE 2.0',
        accessor: 'reasoning',
        getCustomStyles: () => ({
          display: 'none',
          padding: 0,
        }),
        Cell: (props) => {
          const latestHistoryData = props.getLatestRowData(props.row.index);
          const latestReasoning = latestHistoryData?.reasoning || '';
          const currentValue = props.value || '';
          const isReasoningChanged = latestHistoryData && trim(latestReasoning) !== trim(currentValue);
          return (
            <CellWithBackground color={isReasoningChanged && changedValueCellHexColor}>
              {props.isAdmin ? (
                <EditableCell
                  {...props}
                  isDisabled={props.isBespokeModule}
                />
              ) : (
                props.value || ''
              )}
            </CellWithBackground>
          );
        },
      },
      {
        Header: 'Reasoning INVISIBLE 2.1',
        id: 'scoring-expander',
        getCustomStyles: () => ({
          width: '3.5rem',
          display: 'none',
        }),
        Cell: ({ row }) => (
          <ToggleSubcomponent
            {...row.getToggleRowExpandedProps()}
            isExpanded={row.isExpanded}
          />
        ),
      },
    ],
  },
];

const isValidScore = (val) => {
  if (isEmpty(val)) return true;
  try {
    const score = parseInt(val);
    const decimalScore = parseFloat(val);
    return score === decimalScore && score >= 0 && score <= 100;
  } catch {
    return false;
  }
};

export const CellWithBackground = styled.div`
  padding: 0.5rem;
  background-color: ${({ color }) => color || 'inherit'};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
`;
